export default __webpack_public_path__ + "static/media/logOut.114f4cd8.svg";